import { ValidatePasswordRules } from './ChangePasswordForm.types'

function isValid(rule: number, count: number) {
  if (rule === 2) {
    return undefined
  }

  return count >= 1
}

export function validatePassword(value: string, rules: ValidatePasswordRules) {
  const { MinLength, UpperCase, LowerCase, Numbers, SpecialChars1, SpecialChars2, Specials1, Specials2 } = rules

  const symbolCounts = {
    upper: 0,
    lower: 0,
    numbers: 0,
    special1: 0,
    special2: 0,
  }

  for (let i = 0; i < value.length; i++) {
    const char = value.charAt(i)

    if (/(?=.*[A-Z])/.test(char)) {
      symbolCounts.upper += 1
    } else if (/(?=.*[a-z])/.test(char)) {
      symbolCounts.lower += 1
    } else if (/(?=.*[0-9])/.test(char)) {
      symbolCounts.numbers += 1
    } else if (SpecialChars1.indexOf(char) !== -1) {
      symbolCounts.special1 += 1
    } else if (SpecialChars2.indexOf(char) !== -1) {
      symbolCounts.special2 += 1
    }
  }

  return {
    isAllowed: /^[ A-Za-z0-9_@./#&+-<>?=()*^%$!`~|/[\]\\{},.;:'"]*$/.test(value),
    length: value.length >= MinLength,
    upper: isValid(UpperCase, symbolCounts.upper),
    lower: isValid(LowerCase, symbolCounts.lower),
    numbers: isValid(Numbers, symbolCounts.numbers),
    special1: isValid(Specials1, symbolCounts.special1),
    special2: isValid(Specials2, symbolCounts.special2),
  }
}
